import React from "react";
import {
    Grid,
    Typography,
    TextField as MuiTextField, FormGroup, FormControlLabel, Checkbox,
} from "@mui/material";

// Types
import {FieldsGroupType} from "../../../types/fieldsGroup";

// Styling
import {spacing} from "@mui/system";
import styled from "styled-components/macro";



const TextField = styled(MuiTextField)<{ my?: number }>(spacing);


const TechnicalSpecificationProduct: React.FC<FieldsGroupType> = (props) => {
    const {data, values, touched, errors, onChange, state, multiEdit} = props;


    //------------------------------- Public methods -------------------------------------


    return (
        <React.Fragment>
            <Typography variant="h6" mb={5}>
               Note
            </Typography>

            <Grid container spacing={6}>
                <Grid item xs={12} mb={5}>
                    <TextField
                        label="Technical specifications Note"
                        name="technicalSpecificationsNote"
                        multiline
                        rows={4}
                        fullWidth
                        value={values.technicalSpecificationsNote ? values.technicalSpecificationsNote : ''}
                        onChange={onChange}
                    />
                    {multiEdit &&
                        <FormGroup className="clear-check">
                            <FormControlLabel control={
                                <Checkbox
                                    name="clearTechnicalSpecificationsNote"
                                    checked={state.clearTechnicalSpecificationsNote ? state.clearTechnicalSpecificationsNote : false}
                                    onChange={(e) =>{onChange(e)}}
                                />
                            } label="Clear"/>
                        </FormGroup>
                    }
                </Grid>
            </Grid>
        </React.Fragment>
    );
}


export default TechnicalSpecificationProduct;
